export default "__VITE_ASSET__Bi5H2uTd__"